module.exports = __webpack_public_path__ + "static/media/8.61fdda80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/8.jpg
// module id = 61
// module chunks = 0